import { Button, Form } from "antd";
import styled from "styled-components";
import { getStatusTheme } from "../../statusThemes";

/**
 * Column header text/icon/count color is driven by the status theme's pillColor.
 * All status palette decisions live in statusThemes.ts (single source of truth).
 */
export const getColumnHeaderColor = (status?: number): string => {
  if (typeof status !== "number") return "#4a4a4a";
  return getStatusTheme(status).pillColor;
};

export const HeaderWrapper = styled.div`
    display: flex;
    height: 20px;
    margin-bottom: 3px;
    padding: 10px 0;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    border-radius: 2px;
    color: #4a4a4a;
    font-weight: 500;
    transition: background-color 0.3s ease, padding 0.3s ease;

    &.columnHeader{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &:hover {
        cursor: pointer;
        padding: 10px 10px;
        background-color: #f0f0f0;
    }
`;

export const HeaderIcon = styled.div<{ $status?: number; $colorOverride?: string | null }>`
  font-size: 16px;
  color: ${({ $status, $colorOverride }) => $colorOverride || getColumnHeaderColor($status)};
`;

export const HeaderTitle = styled.span<{ $status?: number; $colorOverride?: string | null }>`
  font-size: 16px;
  font-weight: bold;
  color: ${({ $status, $colorOverride }) => $colorOverride || getColumnHeaderColor($status)};
`;

export const HeaderCount = styled.span<{ $status?: number; $colorOverride?: string | null }>`
  font-weight: bold;
  color: ${({ $status, $colorOverride }) => $colorOverride || getColumnHeaderColor($status)};
  font-size: 14px;
`;

export const HeaderFormWrapper = styled(Form)`
    display: flex;
    align-items: center;
    margin: 0;

  .ant-form-item {
    margin: 0;
    display: flex;
    align-items: center;
  }

  .ant-input {
    height: 28px;
    padding: 4px 8px;
    font-size: 14px;
  }
`;

export const StyledCircleButton = styled(Button)`
&.ant-btn{
  width: 26px;
  height: 26px;
  min-width: 26px !important;
}
  margin-left: auto;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .anticon {
    width: 16px;
    height: 16px;
  }
`;

export const HeaderTitleLeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderTitleRightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;